module.exports = __webpack_public_path__ + "img/Streak.e8ec6e01.gif";